import { render, staticRenderFns } from "./ModalEdicion.vue?vue&type=template&id=c5ccc068&"
import script from "./ModalEdicion.vue?vue&type=script&lang=ts&"
export * from "./ModalEdicion.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports